module.exports = __webpack_public_path__ + "912b9ee743525a6dd9b3a0f5a4c06945.pdf";